import { TableCell, TableRow } from "@mui/material"

export function ModifierRuleRow({ item }) {
    return (
        <TableRow>
            <TableCell>{item.ruleName}</TableCell>
            <TableCell align="right">{item.taskCount}</TableCell>
            <TableCell align="right">{formatModifierRuleImpact(item)}</TableCell>
        </TableRow>
    )
}

export function formatModifierRuleImpact(item) {
    if (item.actionType === "timeModifier") return formatTime(item)
    if (item.actionType === "frequencyModifier") return formatFrequency(item.frequencyMultiplier)
    if (item.costKind === "fixed") return formatFixedAmount(item.fixedAmount)
    return `${formatMultiplier(item.multiplier)}x`
}

function formatFixedAmount(value) {
    const amount = Number(value) || 0
    const sign = amount >= 0 ? "+" : ""
    return `${sign}${amount} fixed`
}

function formatTime(item) {
    if (item.timeKind === "percentage") {
        const pct = Math.round((Number(item.timeValue) || 0) * 100)
        const sign = pct >= 0 ? "+" : ""
        return `${sign}${pct}%`
    }
    const minutes = Number(item.timeValue) || 0
    const sign = minutes >= 0 ? "+" : ""
    return `${sign}${minutes} min`
}

function formatFrequency(multiplier) {
    return `${formatMultiplier(multiplier)}x`
}

function formatMultiplier(multiplier) {
    const value = Number(multiplier) || 1
    return (Math.round(value * 100) / 100).toFixed(2)
}
